/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const problemAlternativeDtoSchema = z.object({
  alternative: z.optional(z.string()),
  limitation: z.optional(z.string()),
});
